import script from "./UProgressBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./UProgressBar.vue?vue&type=script&setup=true&lang=ts"

import "./UProgressBar.vue?vue&type=style&index=0&id=0a94d5bd&lang=scss"

const __exports__ = script;

export default __exports__